import { useValidationFormLoader } from '../ValidationFormLoader';
import { Col, Container, Row } from 'reactstrap';
import ValidationForm, { ValidationFormProps } from './ValidationForm';
import Loading from '../../../../components/info/Loading';
import useTextValidationType from '../../../../components/curriculum/hooks/useTextValidationType';

const ValidationFormWrapper = (
  props: Omit<
    ValidationFormProps,
    | 'courseEnrollments'
    | 'institutions'
    | 'validationTypeOptions'
    | 'validationSubTypeOptions'
  >,
) => {
  const { data, loading } = useValidationFormLoader();
  const { validationOptions, rapOptions } = useTextValidationType();

  if (loading) {
    return (
      <Container>
        <Row>
          <Col xs={12}>
            <Loading insideCard />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <ValidationForm
      {...props}
      courseEnrollments={data?.courseEnrollments}
      institutions={data?.institutions}
      validationTypeOptions={validationOptions}
      validationSubTypeOptions={rapOptions}
    />
  );
};

export default ValidationFormWrapper;
